import React from 'react';
import PropTypes from 'prop-types';

const TileListGroupHeading = ({
  children = null,
  testId = 'tile-list-group-heading'
}) => (
  <div
    data-testid={testId}
    className="text-lg font-semibold text-charcoal text-opacity-90 mt-6"
  >
    {children}
    <hr className="border-charcoal border-opacity-50" />
  </div>
);

TileListGroupHeading.propTypes = {
  children: PropTypes.node,
  testId: PropTypes.string
};

export default TileListGroupHeading;
